import { jsx } from "../../../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.es.js";
import "../../../../node_modules/@bonusx-global/bx-icons/dist/node_modules/react/jsx-runtime.es.es.js";
import "../../../../node_modules/@bonusx-global/bx-icons/dist/node_modules/@emotion/react/dist/emotion-element-c39617d8.browser.esm.es.es.js";
import "react";
import "../../../../node_modules/@bonusx-global/bx-icons/dist/node_modules/hoist-non-react-statics/dist/hoist-non-react-statics.cjs.es.es.js";
import "../../../../node_modules/@bonusx-global/bx-icons/dist/node_modules/@emotion/serialize/dist/emotion-serialize.browser.esm.es.es.js";
import { styled } from "@mui/material";
import { TrashOutlined as i } from "../../../../node_modules/@bonusx-global/bx-icons/dist/src/icons/outlined/trash-outlined.es.es.js";
import "../../../../node_modules/@bonusx-global/bx-icons/dist/src/icons/solid/turn-icons.es.es.js";
import { Displaying } from "../../../foundations/displaying.es.js";
import { Alignment } from "../../../foundations/alignment.es.js";
import { IconButton } from "../../icon-button/icon-button.es.js";
const CustomTrashIconContainer = styled("div")({
  display: Displaying.flex,
  justifyContent: Alignment.end
});
function DropzoneClearButton({
  onClick,
  clearButtonId
}) {
  return /* @__PURE__ */ jsx(CustomTrashIconContainer, { children: /* @__PURE__ */ jsx(IconButton, { id: clearButtonId, className: "clear-button", color: "default", size: "medium", onClick, children: /* @__PURE__ */ jsx(i, { color: "action" }) }) });
}
export {
  DropzoneClearButton
};
//# sourceMappingURL=clear-button.es.js.map
